import { render, staticRenderFns } from "./Garden.vue?vue&type=template&id=7458cb08&"
import script from "./Garden.vue?vue&type=script&lang=js&"
export * from "./Garden.vue?vue&type=script&lang=js&"
import style0 from "./Garden.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports